// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useTheme } from '@azure/communication-react';
import { IStackStyles, ITheme, Stack } from '@fluentui/react';

export const PromptStarter = (props: { body: React.ReactNode; icon: React.ReactNode }): JSX.Element => {
  const theme = useTheme();
  return (
    <Stack horizontal tokens={{ childrenGap: '0.5rem' }} styles={promptContainerStyles(theme)}>
      <Stack.Item>{props.icon}</Stack.Item>
      <Stack.Item>{props.body}</Stack.Item>
    </Stack>
  );
};

const promptContainerStyles = (theme: ITheme): IStackStyles => ({
  root: {
    padding: '0.75rem',
    backgroundColor: `${theme.palette.white}`,
    borderRadius: '0.5rem',
    borderColor: theme.palette.neutralQuaternaryAlt
  }
});
